export const kebabize = (str: string): string =>
  str
    .replace(
      /[A-Z]+(?![a-z])|[A-Z]/g,
      ($, ofs) => (ofs ? '-' : '') + $.toLowerCase(),
    )
    .replace(/[^A-Za-z-.]/gm, '')
    .replaceAll('.-', '.')
    .replace(/[-]{2,}/gm, '-');
